module.exports={
	"Form": "DocumentApprovalWorkflowViewManifest",
	"Scope": "DocumentApprovalWorkflow-View",
	"Descriptors":
	{
		"DocumentApprovalWorkflowDetails.IDDocumentApprovalWorkflow":
		{
			"Name": "ID",
			"Hash": "DocWfView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "DocWfIdentity",
				"Group": "DocWfIdentity"
			}
		},
		"DocumentApprovalWorkflowDetails.Name":
		{
			"Name": "Transition Name",
			"Hash": "DocWfView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 10,
				"Section": "DocWfIdentity",
				"Group": "DocWfIdentity"
			}
		},
		"DocumentApprovalWorkflowDetails.FromStatus":
		{
			"Name": "From Status",
			"Hash": "DocWfView-FromStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "DocWfConfig",
				"Group": "DocWfConfig"
			}
		},
		"DocumentApprovalWorkflowDetails.ToStatus":
		{
			"Name": "To Status",
			"Hash": "DocWfView-ToStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "DocWfConfig",
				"Group": "DocWfConfig"
			}
		},
		"DocumentApprovalWorkflowDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "DocWfView-IDProject",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "DocWfConfig",
				"Group": "DocWfConfig"
			}
		},
		"DocumentApprovalWorkflowDetails.EdgeOptions":
		{
			"Name": "Edge Options (JSON)",
			"Hash": "DocWfView-EdgeOptions",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "DocWfEdgeOptions",
				"Group": "DocWfEdgeOptions"
			}
		},
		"DocumentApprovalWorkflowDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "DocWfView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocWfAudit",
				"Group": "DocWfAudit"
			}
		},
		"DocumentApprovalWorkflowDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "DocWfView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocWfAudit",
				"Group": "DocWfAudit"
			}
		},
		"DocumentApprovalWorkflowDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "DocWfView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocWfAudit",
				"Group": "DocWfAudit"
			}
		},
		"DocumentApprovalWorkflowDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "DocWfView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocWfAudit",
				"Group": "DocWfAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "DocWfIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "DocWfIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Workflow Configuration",
			"Hash": "DocWfConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Workflow Configuration",
					"Hash": "DocWfConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Edge Options",
			"Hash": "DocWfEdgeOptions",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Edge Options",
					"Hash": "DocWfEdgeOptions",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "DocWfAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "DocWfAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
